// index.js
import Vue from 'vue'
import VueDragscroll from "vue-dragscroll";
import App from './App.vue'
Vue.config.productionTip = false
Vue.use(VueDragscroll)

new Vue({
    el: '#calendar',
    components: {
        'calendar-app' : App
    }
})
